<template>
  <v-expand-transition>
    <v-row>
      <v-col v-for="ps in posizioni" :key="ps">
        <v-btn :disabled="trigger && !posizioneOccupata(ps)" @click="selezionaPosizione(ps)">{{`2P ${ps}`}}</v-btn>
      </v-col>
      <v-dialog v-model="dialog" scrollable max-width="800px">
        <v-card>
          <v-card-title>Importa i prodotti dal parcheggio</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-simple-table dense class="mt-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">CODICE</th>
                    <th class="text-left">DESCRIZIONE</th>
                    <th class="text-right">QUANTITA'</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in righe" :key="item._id">
                    <td class="text-left">{{ item.codice }}</td>
                    <td class="text-left">{{ item.descrizione }}</td>
                    <td class="text-right">{{ item.quantita }}</td>
                  </tr>
                </tbody>                
              </template>
            </v-simple-table> 
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog = false">Annulla</v-btn>
            <v-btn color="blue darken-1" text @click="onImporta">Importa</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>            
    </v-row>
  </v-expand-transition>
</template>

<script>
  import _ from 'lodash'
  import scontrini from '@/services/scontriniService.js'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    props: {
      show: Boolean
    },
    data: () => ({
      parcheggiati: [],
      impostazioniOrdine: null,
      ordiniDefault: {
        parcheggio: {
          zona: 2,
          righe: 7,
          colonne: 7
        }
      },
      dialog: false,
      righe: [],
      trigger: 1,
      idParcheggio: null
    }),
    watch: {
      async show(value) {
        if (value) {
          await this.refresh()
        }
      }
    },
    computed: {
      posizioni() {
        if (!this.impostazioniOrdine) return []
        const { zona, righe, colonne } = this.impostazioniOrdine.parcheggio
        let posizioni = []
        for (let r = 1; r <= righe; r++) {
          for (let c = 1; c <= colonne; c++) {
            posizioni.push(`${zona}.${r}.${c}`)
          }
        }
        return posizioni
      }
    },
    async mounted() {
      // const backoffice = await configurazioni.getConfigurazione('mobile', 'platform')
      // this.impostazioniOrdine = _.get(backoffice, 'impostazioni.ordini.creazione', this.ordiniDefault)   
      // Diverso tra ordini cliente e picking
      this.impostazioniOrdine =  this.ordiniDefault 
      await this.refresh()
    },
    methods: {
      async refresh() {
        this.parcheggiati = await scontrini.getParcheggiati()
        this.trigger++
      },
      async onImporta() {
        const righe = this.righe.map(x => { return { codice: x.codice, quantita: x.quantita }})
        this.$root.$emit('aggiungiProdotti', righe)
        await scontrini.annullaParcheggio(this.idParcheggio)
        this.dialog = false
      },
      posizioneOccupata(ps) {
        const zona = this.ordiniDefault.parcheggio.zona
        const posizione = `${zona}.${ps}`
        const occupato = this.parcheggiati.find(x => x.parcheggio.posizione === ps)
        return occupato ? true : false
      },
      selezionaPosizione(ps) {
        const parcheggio = this.parcheggiati.find(x => x.parcheggio.posizione === ps)
        const righe = parcheggio.righe
        this.idParcheggio = parcheggio._id
        this.righe = righe
        this.dialog = true
      }
    }
  }
</script>
